module.exports = __webpack_public_path__ + "static/img/yq_logo.17552fcb.png";